import React, { Fragment } from 'react'
import classnames from 'classnames'

import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import IconButton from '@material-ui/core/IconButton'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { CONTRACT_TYPE_TO_NAME_MAP } from '../../../../../../../shared/constants'
import Collapse from '@material-ui/core/Collapse'
import Box from '@material-ui/core/Box'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableBody from '@material-ui/core/TableBody'
import { DAY_TIMES, DAYS_OF_WEEK } from './options'
import { convertTypeToLabel, getColSpan, getTypeByAccessibility } from './utils'
import StyledTooltip from '../Tooltip'
import noticePeriod from '../../assets/noticePeriod.svg'

const Row = ({
  row,
  bookBa,
  classes,
  showDistance,
  openRowIds,
  setOpenRowIds,
  highligthedAvailability,
}) => {
  const {
    userId,
    distance,
    isNoticePeriod,
    accessibilityWithMissions: {
      availableExtraMissions,
      availableMissions,
      extraMissionUsed,
      maxMissionPerWeek,
      userMissionInThisWeek,
      accessibility,
    },
  } = row

  const getDistanceItem = value => {
    if (value >= 5) {
      return <div className={classes.distanceRed}>{value} km</div>
    } else if (value < 5 && value >= 3) {
      return <div className={classes.distanceYellow}>{value} km</div>
    } else if (value < 3 && value >= 2) {
      return <div className={classes.distanceYellowGreen}>{value} km</div>
    } else if (value < 2 && value >= 1) {
      return <div className={classes.distanceGreen}>{value} km</div>
    } else if (value < 1 && value > 0) {
      return <div className={classes.distanceFullGreen}>{value} km</div>
    } else {
      return <div className={classes.distanceNot}>-</div>
    }
  }
  const handleOpen = userId => {
    setOpenRowIds(prev => {
      if (prev.includes(userId)) {
        return prev.filter(item => item !== userId)
      } else {
        return [...prev, userId]
      }
    })
  }

  const isExpanded = openRowIds.includes(userId)

  return (
    <Fragment>
      <TableRow
        className={classnames(classes.rowRoot, {
          [classes.isNoticePeriod]: isNoticePeriod,
        })}
      >
        <TableCell className={classes.relative}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => handleOpen(userId)}
          >
            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
          {isNoticePeriod ? (
            <div className={classes.isNoticePeriodIcon}>
              <StyledTooltip
                title="This BA is currently on notice period"
                styles={{ bottom: '20px' }}
              >
                <img src={noticePeriod} alt="icon" />
              </StyledTooltip>
            </div>
          ) : null}
        </TableCell>
        <TableCell component="th" scope="row">
          {row.name}
        </TableCell>
        <TableCell align="left">
          {CONTRACT_TYPE_TO_NAME_MAP[row.documentType]}
        </TableCell>
        <TableCell align="center">{userMissionInThisWeek}</TableCell>
        <TableCell align="center">{availableMissions}</TableCell>
        <TableCell align="center">{extraMissionUsed}</TableCell>
        <TableCell align="center">{availableExtraMissions}</TableCell>
        <TableCell align="center">{maxMissionPerWeek}</TableCell>
        {showDistance ? (
          <TableCell align="center">{getDistanceItem(distance)}</TableCell>
        ) : null}
        {bookBa ? (
          <TableCell align="center">
            <div
              onClick={() => bookBa({ userId, data: row })}
              className={classes.link}
            >
              Book Ba
            </div>
          </TableCell>
        ) : null}
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0 }}
          colSpan={getColSpan({ bookBa, showDistance })}
        >
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Table size="small" aria-label="accessibility">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.headerSubTableFirstRow} />
                    {DAYS_OF_WEEK.map(header => (
                      <TableCell
                        className={classnames(
                          classes.tableHeader,
                          classes.headerSubTable,
                        )}
                        align="center"
                        key={header}
                      >
                        {convertTypeToLabel(header)}
                      </TableCell>
                    ))}
                  </TableRow>
                  {DAY_TIMES.map(dayTime => (
                    <TableRow key={dayTime}>
                      <TableCell className={classes.tableHeader}>
                        {convertTypeToLabel(dayTime)}
                      </TableCell>
                      {DAYS_OF_WEEK.map(day => {
                        const {
                          hint,
                          background,
                          onClick,
                        } = getTypeByAccessibility(accessibility[day][dayTime])

                        const isHighligthed = highligthedAvailability
                          ? day == highligthedAvailability.day &&
                            dayTime == highligthedAvailability.timeOfDay
                          : false

                        const styles = [
                          DAYS_OF_WEEK[0],
                          DAYS_OF_WEEK[1],
                        ].includes(day)
                          ? { left: 0 }
                          : DAYS_OF_WEEK[5] === day
                          ? { right: '40px' }
                          : { right: 0 }

                        return (
                          <TableCell
                            key={day}
                            className={classes.wrapperSquare}
                          >
                            <StyledTooltip title={hint} styles={styles}>
                              <div
                                onClick={onClick ? onClick : () => {}}
                                className={classes.square}
                                style={{
                                  background,
                                  border: isHighligthed ? '1px solid red' : '',
                                  cursor: onClick ? 'pointer' : 'inherit',
                                }}
                              />
                            </StyledTooltip>
                          </TableCell>
                        )
                      })}
                    </TableRow>
                  ))}
                </TableHead>
                <TableBody />
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  )
}

export default Row
